import * as Yup from "yup";
import contaPagarValidator from "../../addContaPagar/middlewares/contaPagar.validator";

const listaContaPagarValidator = Yup.array()
  .of(
    contaPagarValidator.shape({
      rateiosCentroCustoList: Yup.array().nullable().optional(),
      rateiosPlanoFinanceiroList: Yup.array().nullable().optional(),
    })
  )
  .min(1, "Selecione no mínimo uma conta a baixar");

export default listaContaPagarValidator;